<!--
 * @Author: your name
 * @Date: 2022-04-19 15:45:49
 * @LastEditTime: 2022-07-18 09:02:04
 * @LastEditors: daidongyu daidongyu@cnuri.cn
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /my-activation/src/mall/index.vue
-->
<template>
  <div class="recharge">
    <mt-loadmore
      @top-status-change="handleTopChange"
      :top-method="loadTop"
      ref="loadmore"
    >
      <div slot="top" class="mint-loadmore-top" style="text-align:center"></div>
      <div class="bg_color">
        <div class="head_shop">
          <div class="left_logo">
            <img
              :src="
                shopData.iconUrl
                  ? shopData.iconUrl
                  : '../../static/image/bgimg.png'
              "
              alt=""
            />
          </div>
          <div>
            <p class="shop_name">{{ shopData.name }}</p>
            <p class="shop_content">
              营业时间:{{ moment(saleTempInfo.openAt).format("HH:mm") }}--{{
                moment(saleTempInfo.closeAt).format("HH:mm")
              }}
            </p>
          </div>
          <div class="Tips_lo" @click="explain = true" style="background:#fff">
            ?
          </div>
        </div>
      </div>
      <div class="goods_list">
        <div class="list_item" v-for="(item, index) in list" :key="index">
          <div class="item_img">
            <img
              :src="item.imgUrl ? item.imgUrl : '../../static/image/bgimg.png'"
            />
          </div>
          <div class="item_center">
            <p class="center_tit">{{ item.name }}</p>
            <p class="center_count">
              库存：{{ item.stock }} | 单位：{{ item.unit }}
            </p>
            <p class="center_price">￥{{ item.normalPrice }}</p>
          </div>
          <div class="item_tot">
            <span
              class="tot_jian"
              @click="handleChange(false, item)"
              v-if="item.cartInfo && item.cartInfo.number"
              >—</span
            >
            <span
              class="tot_count"
              v-if="item.cartInfo && item.cartInfo.number"
              >{{ item.cartInfo.number || 0 }}</span
            >
            <span class="tot_jia" @click="handleChange(true, item)">+</span>
          </div>
        </div>
      </div>

      <!-- 规则弹窗 -->
      <div class="mask" v-if="explain || showShopCar" @click="hideModal"></div>
      <div class="mask_white" v-if="addCar" @click="hideModal"></div>
      <div class="alert_rules" v-if="explain">
        <img
          src="../../static/image/closed.png"
          class="closebtn"
          @click="explain = false"
        />
        <p class="rules_tit">门店说明</p>
        <p class="rules_con">
          {{ saleTempInfo.description }}
        </p>
      </div>
      <!-- 购物车 -->
      <div :class="showShopCar ? 'shopingCarShow' : 'shopingCar'">
        <div class="carMask" v-if="addCar"></div>
        <div class="del_car" @click="clearCar">
          <p>清空购物车</p>
        </div>
        <div class="list_wrap">
          <div
            class="list_item"
            v-for="(item, index) in carData"
            :key="index"
            v-if="item.cartInfo && item.cartInfo.number > 0"
          >
            <div class="item_img">
              <img
                :src="
                  item.imgUrl ? item.imgUrl : '../../static/image/bgimg.png'
                "
              />
            </div>
            <div class="item_center">
              <p class="center_tit">{{ item.name }}</p>
              <p class="center_count">
                库存：{{ item.stock }} | 单位：{{ item.unit }}
              </p>
              <p class="center_price">￥{{ item.normalPrice }}</p>
            </div>
            <div class="item_tot">
              <span
                class="tot_jian"
                @click="handleChange(false, item)"
                v-if="item.cartInfo && item.cartInfo.number"
                >—</span
              >
              <span
                class="tot_count"
                v-if="item.cartInfo && item.cartInfo.number"
                >{{ item.cartInfo.number || 0 }}</span
              >
              <span class="tot_jia" @click="handleChange(true, item)">+</span>
            </div>
          </div>
        </div>
      </div>
      <div class="Ret" @click="clickTab"><span>返回首页</span></div>
    </mt-loadmore>
    <!-- 底部 -->
    <div class="footers">
      <div class="car" @click="handleCarPrew">
        <span class="car_count">{{ carInfo.goodsTotal || 0 }}</span>
        <img src="../../static/image/shopcar.png" alt="" />
      </div>
      <div class="car_main">
        <p class="car_money">￥{{ carInfo.costTotal || 0 }}</p>
        <p class="car_rules">预估另需配送费￥{{ saleTempInfo.deliveryCost }}</p>
      </div>
      <div class="jiesuan" @click="hrefToOrder" v-if="sendStatus <= 0">
        去结算
      </div>
      <div class="car_send" v-else>还差{{ sendStatus }}元起送</div>
    </div>
  </div>
</template>
<script>
import { Toast, Indicator } from "mint-ui";
export default {
  name: "Detail",
  data() {
    return {
      explain: false,
      showShopCar: false,
      list: [],
      carData: [],
      carInfo: {},
      saleTempInfo: {},
      shopData: {},
      openID: localStorage.getItem("code"),
      addCar: false,
      companyID: localStorage.getItem("companyID"),
      VIPNO: localStorage.getItem("VIPNO"),
      queryCompanyID: ""
    };
  },
  mounted() {
    // https://api.cnuri.cn/vip-h5/api/v2/h5/vip?companyID=621f16f43c0a4c3b5d05a14b
    this.queryCompanyID = this.$route.query.companyID;

    // 是否有店铺信息
    if (!JSON.parse(localStorage.getItem("shopList"))) {
      this.RequestMall("GET", "h5/mall/shop/all", {}, r => {
        localStorage.setItem("shopID", r.data.data.result[0].id);
        localStorage.setItem("shopList", JSON.stringify(r.data.data.result));
        this.shopData = r.data.data.result[0];
        this.getData();
      });
    } else {
      this.getData();
      this.shopData = JSON.parse(localStorage.getItem("shopList"))[0];
    }
  },
  methods: {
    handleTopChange() {
      console.log("1111111112233");
    },
    loadTop() {
      console.log("qwertykjgfdsaxcvbnm");
      this.$refs.loadmore.onTopLoaded();
    },
    clickTab() {
      // console.log(this.openID);
      if (!!this.openID) {
        window.location.href = "/#/BindingMenmberCard";
      } else {
        const baseUrl = window.location.origin;
        window.location.href = `${baseUrl}/vip-h5/api/v2/h5/vip?companyID=${this.queryCompanyID}`;
      }
    },
    getData() {
      // 商户信息
      const shopID = localStorage.getItem("shopID");
      // 商品信息
      this.RequestMall(
        "GET",
        `h5/mall/goods/all?shopID=${shopID}&openID=${this.openID}`,
        {},
        res => {
          const { cartInfo, goodsList, saleTempInfo } = res.data.data;
          this.carInfo = cartInfo;
          this.list = goodsList;
          this.saleTempInfo = saleTempInfo;
        },
        err => console.log(err)
      );
    },
    // 购物车商品
    handleCarPrew() {
      this.showShopCar = true;
      this.getCarData();
    },
    getCarData() {
      this.RequestMall(
        "GET",
        `h5/mall/cart/goods/all?saleTempID=${this.saleTempInfo.id}&openID=${this.openID}`,
        {},
        res => {
          this.carData = res.data.data.result;
          console.log(res);
        }
      );
    },
    hideModal() {
      this.explain = false;
      this.showShopCar = false;
    },
    // 结算
    hrefToOrder() {
      console.log("************");
      const start = parseInt(
        this.moment(this.saleTempInfo.openAt)
          .format("HH:mm:ss")
          .split(":")
          .join("")
      );
      const end = parseInt(
        this.moment(this.saleTempInfo.closeAt)
          .format("HH:mm:ss")
          .split(":")
          .join("")
      );
      const now = parseInt(
        this.moment()
          .format("HH:mm:ss")
          .split(":")
          .join("")
      );

      if (now >= start && now <= end) {
        window.location.href = "/#/Order";
      } else {
        Toast("本店已打烊！");
      }
    },
    // 清空购物车
    clearCar() {
      this.RequestMall(
        "GET",
        `h5/mall/cart/goods/clear?openID=${this.openID}`,
        {},
        r => {
          console.log(r, "ressssssss");
          Toast("清空购物车成功！");
          this.showShopCar = false;
          this.getData();
        }
      );
    },
    // 选品
    async handleChange(status, item) {
      // !this.openID || !this.companyID || !this.VIPNO||this.queryCompanyID
      if (!this.openID || !this.companyID) {
        localStorage.setItem("toShop", true);
        Indicator.open({
          text: "用户未授权,正在跳转授权页...",
          spinnerType: "fading-circle"
        });
        setTimeout(() => {
          const baseUrl = window.location.origin;
          window.location.href = `${baseUrl}/vip-h5/api/v2/h5/vip?companyID=${this.queryCompanyID}`;
          Indicator.close();
        }, 2000);
        return;
        // 跳转授权
      } else if (!!this.openID && !this.VIPNO) {
        localStorage.setItem("toShop", true);
        Indicator.open({
          text: "用户未注册,正为您跳转首页选择注册或绑定会员卡.",
          spinnerType: "fading-circle"
        });
        setTimeout(() => {
          window.location.href = `/#/BindingMenmberCard`;
          Indicator.close();
        }, 3000);
        return;
        // 去注册
      }
      if (!item.cartInfo || !item.cartInfo.number) {
        item.cartInfo = { number: 0 };
      }

      if (item.cartInfo.number + 1 > item.stock && !!status) {
        Toast("购买数量不能大于库存");
        return;
      }
      this.addCar = true;
      Indicator.open({
        spinnerType: "fading-circle"
      });
      await this.RequestMall(
        "POST",
        "h5/mall/cart/goods",
        {
          saleTempID: this.saleTempInfo.id,
          openID: this.openID,
          goodsID: item.id,
          number: status ? 1 : -1
        },
        r => {
          this.getData();
          this.getCarData();
          Indicator.close();
          this.addCar = false;
        }
      );
    }
  },
  computed: {
    sendStatus() {
      return (
        this.saleTempInfo.minimumDeliveryAmount - this.carInfo.costTotal
      ).toFixed(2);
    }
  }
};
</script>
<style scoped>
.recharge {
  font-size: 8px;
  width: 100%;
  height: 100vh;
  overflow-x: hidden;
  overflow-y: scroll;
  -webkit-overflow-scrolling: auto;
  /* position: relative; */
  -webkit-overflow-scrolling: touch;
  /* -webkit-text-size-adjust: none; */
}
::-webkit-scrollbar {
  display: none;
}
.main_headimg {
  width: 40px;
  height: 40px;
}
.bg_color {
  width: 100%;
  height: 91px;
  background: linear-gradient(310deg, #ff9c60 0%, #ff5a61 100%);
  opacity: 1;

  box-sizing: border-box;
  padding: 20px 0 11px;
  position: relative;
}
.head_shop {
  width: 94%;
  height: 69px;
  background: #fff;
  position: absolute;
  left: 3%;
  bottom: -12px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.16);
  border-radius: 7px;
  display: flex;
  justify-content: flex-start;
  padding: 13px 11px;
  box-sizing: border-box;
}
.Tips_lo {
  width: 12px;
  height: 12px;
  line-height: 12px;
  text-align: center;
  border-radius: 50%;
  color: #757575;
  border: solid 1px #757575;
  /* background: linear-gradient(95deg, #ff5a61 0%, #ff9c60 100%); */
  margin-top: 4px;
  margin-right: 3%;
  font-size: 10px;
  position: absolute;
  right: 13px;
  top: 13px;
}
.left_logo {
  width: 44px;
  height: 44px;
  background: rgba(255, 255, 255, 0.39);
  border: 1px solid #bdbdbd;
  opacity: 1;
  border-radius: 3px;
  box-sizing: border-box;
  padding: 7px;
}
.left_logo img {
  width: 28px;
  height: 28px;
  display: inline-block;
  background: rgba(0, 0, 0, 0);
  opacity: 1;
}
.shop_name {
  height: 11px;
  font-size: 11px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  line-height: 13px;
  color: #212121;
  margin-top: 6px;
  margin-left: 11px;
}
.shop_content {
  height: 8px;
  font-size: 8px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  line-height: 13px;
  color: #757575;
  margin-top: 11px;
  margin-left: 11px;
}
.goods_list {
  margin-top: 20px;
  padding-bottom: 50px;
}
.list_item {
  width: 100%;
  height: 83px;
  background: rgba(255, 255, 255, 0.39);
  /* border: solid 1px; */
  box-sizing: border-box;
  padding: 11px;
  display: flex;
  position: relative;
  justify-content: flex-start;
}
.list_wrap {
  overflow-y: scroll;
  height: 325px;
  padding-bottom: 40px;
  box-sizing: border-box;
}
.item_img {
  width: 61px;
  height: 61px;
}
.item_img img {
  width: 100%;
  height: 100%;
}
.item_center {
  width: 150px;
  overflow: hidden;
  margin-left: 11px;
  position: relative;
}
.center_tit {
  font-size: 11px;
  font-weight: 400;
  line-height: 13px;
  color: #212121;
}
.center_count {
  font-size: 8px;
  line-height: 13px;
  color: #757575;
  margin-top: 4px;
}
.center_price {
  font-size: 14px;
  line-height: 12px;
  color: #fe6262;
  position: absolute;
  left: 0;
  bottom: 0;
}
.item_tot {
  /* width: 80px; */
  position: absolute;
  right: 11px;
  bottom: 11px;
}
.item_tot span {
  display: inline-block;
  font-size: 12px;
  text-align: center;
  line-height: 14px;
}
.item_tot .tot_jian {
  width: 14px;
  height: 14px;
  line-height: 12px;
  border: 1px solid #bdbdbd;
  box-sizing: border-box;
  border-radius: 50px;
  color: #212121;
  font-size: 8px;
  vertical-align: middle;
  cursor: pointer;
}
.item_tot .tot_count {
  font-size: 10px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #212121;
  /* margin: 0 7px; */
  line-height: 12px;
  vertical-align: middle;
  margin: 0 5px;
}
.item_tot .tot_jia {
  width: 14px;
  height: 14px;
  background: #ffa516;
  color: white;
  border-radius: 50px;
  vertical-align: middle;
  cursor: pointer;
}
.footers {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 39px;
  background: rgba(255, 255, 255, 1);
  display: flex;
  justify-content: start;
  padding: 6px 11px;
  box-sizing: border-box;
  z-index: 99;
  border-top: solid 1px #e0e0e0;
}
.car {
  width: 25px;
  height: 25px;
  position: relative;
}
.car img {
  width: 100%;
  height: 100%;
}
.car_count {
  position: absolute;
  right: -5px;
  top: -5px;
  width: 10px;
  height: 10px;
  background: #f2553d;
  border-radius: 50%;
  color: #ffffff;
  padding: 1px;
  text-align: center;
}
.car_main {
  margin-left: 11px;
}
.car_money {
  font-size: 14px;
  line-height: 13px;
  color: #fe6262;
}
.car_rules {
  font-size: 8px;
  line-height: 13px;
  color: #9e9e9e;
  margin-top: 2px;
}
.jiesuan {
  width: 76px;
  height: 25px;
  background: #fe6262;
  border-radius: 69px;
  line-height: 25px;
  color: #ffffff;
  font-size: 10px;
  text-align: center;
  position: absolute;
  right: 11px;
  top: 6px;
}
.car_send {
  font-size: 8px;
  color: #9e9e9e;

  position: absolute;
  right: 11px;
  top: 15px;
}
.alert_rules {
  position: fixed;
  top: 40px;
  left: 10%;
  z-index: 999;
  width: 80%;
  height: 278px;
  background: #fff;
  opacity: 1;
  border-radius: 6px;
  padding: 17px;
  box-sizing: border-box;
}
.mask {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.39);
  position: fixed;
  top: 0;
  left: 0;
}
.mask_white {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0);
  position: fixed;
  top: 0;
  left: 0;
}
.closebtn {
  width: 45px;
  /* height: 40px; */
  position: absolute;
  left: 41%;
  bottom: -45px;
}
.rules_tit {
  font-size: 10px;
  color: #212121;
  padding-bottom: 11px;
}
.rules_con {
  font-size: 8px;
  color: #757575;
}
.shopingCar {
  width: 100%;
  position: fixed;
  bottom: -350px;
  left: 0;
  height: 350px;
  background: #ffffff;
  z-index: 88;
  overflow: scroll;
  padding-bottom: 55px;
  box-sizing: border-box;
  border-radius: 6px 6px 0px 0px;
  transition: all 0.5s;
}
.shopingCarShow {
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  height: 350px;
  background: #ffffff;
  z-index: 88;
  padding-bottom: 55px;
  box-sizing: border-box;
  border-radius: 6px 6px 0px 0px;
  transition: all 0.5s;
  /* position: relative; */
}
.del_car {
  width: 100%;
  height: 25px;
  line-height: 25px;
  background: #f5f5f5;
  font-size: 8px;
  color: #757575;
  text-align: right;
  box-sizing: border-box;
  padding: 0 11px;
}
.del_car p {
  background: url("~../../static/image/delete.png") 79% 6.5px no-repeat;
  background-size: 10px;
}
.carMask {
  width: 100%;
  height: 100%;
  background: rgba(134, 97, 97, 0);
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999;
}
.Ret {
  position: fixed;
  z-index: 9;
  bottom: 170px;
  left: 0px;
  width: 24%;
  height: 20px;
  background: #fff;
  line-height: 20px;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  color: #212121;
  box-shadow: 0px 0px 0.8px 0px #757575;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/mall/index.vue